<template>
  <div>
    <el-card shadow="always">
      <h1>用户组管理</h1>
      <el-button type="primary" @click="showAddGroupDialog = true">添加组</el-button>
      <el-table :data="groups" style="width: 100%">
        <el-table-column prop="name" label="组名" width="180"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="scope">
            <el-button size="small" @click="editGroup(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="deleteGroup(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加组弹窗 -->
      <el-dialog title="添加组" v-model="showAddGroupDialog" width="30%">
        <el-form :model="newGroup" label-width="80px" :rules="rules" ref="addGroupForm">
          <el-form-item label="组名" prop="name">
            <el-input v-model="newGroup.name" placeholder="组名" required></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input v-model="newGroup.description" placeholder="描述" required></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="showAddGroupDialog = false">取消</el-button>
            <el-button type="primary" @click="submitAddGroup">保存</el-button>
          </span>
        </template>
      </el-dialog>
      <!-- 编辑组弹窗 -->
      <el-dialog title="编辑组" v-model="dialogVisible" width="30%">
        <el-form :model="editingGroup" label-width="80px" v-if="editingGroup">
          <el-form-item label="组名">
            <el-input v-model="editingGroup.name" placeholder="组名" required></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="editingGroup.description" placeholder="描述" required></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="cancelEdit">取消</el-button>
            <el-button type="primary" @click="updateGroup">保存</el-button>
          </span>
        </template>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      groups: [],
      newGroup: {
        name: '',
        description: ''
      },
      editingGroup: null,
      dialogVisible: false,
      showAddGroupDialog: false,
      rules: {
        name: [
          { required: true, message: '请输入组名', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.fetchGroups();
  },
  methods: {
    async fetchGroups() {
      try {
        const response = await axios.get('/api/groups');
        this.groups = response.data;
        console.info(this.groups);
        console.log('Fetched groups:', this.groups);
      } catch (error) {
        console.error('获取用户组失败', error);
      }
    },
    async submitAddGroup() {
      this.$refs.addGroupForm.validate(async (valid) => {
        if (valid) {
          try {
            await axios.post('/api/groups', this.newGroup);
            this.newGroup.name = '';
            this.newGroup.description = '';
            this.fetchGroups();
            this.showAddGroupDialog = false;
            this.$message({
              message: '用户组添加成功',
              type: 'success'
            });
          } catch (error) {
            if (error.response && error.response.data && error.response.data.detail) {
              this.$message({
                message: error.response.data.detail,
                type: 'error'
              });
            } else {
              this.$message({
                message: '用户组添加失败，请检查输入信息',
                type: 'error'
              });
            }
          }
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
    editGroup(group) {
      this.editingGroup = { ...group };
      console.log('Editing group:', this.editingGroup);
      this.dialogVisible = true;
    },
    async updateGroup() {
      try {
        console.log('Updating group with ID:', this.editingGroup.id);
        const response = await axios.put(`/api/groups/${this.editingGroup.id}`, this.editingGroup);

        // 更新本地的 groups 数据
        const updatedGroup = response.data;
        const index = this.groups.findIndex(group => group.id === updatedGroup.id);
        if (index !== -1) {
          this.groups.splice(index, 1, updatedGroup);
        }

        // 关闭对话框
        this.dialogVisible = false;

        // 清空编辑组数据
        this.editingGroup = null;

        console.log('Group updated successfully:', updatedGroup);
      } catch (error) {
        console.error('更新用户组失败', error);
      }
    },
    cancelEdit() {
      this.editingGroup = null;
      this.dialogVisible = false;
    },
    async deleteGroup(id) {
      try {
        console.log('Deleting group with ID:', id);
        await axios.delete(`/api/groups/${id}`);
        this.fetchGroups();
      } catch (error) {
        console.error('删除用户组失败', error);
      }
    }
  }
};
</script>

<style scoped>
/* 添加一些基本样式 */
.el-form {
  margin-bottom: 20px;
}
.el-input {
  margin-right: 10px;
}
.el-button {
  margin-right: 10px;
}
</style>
